<template>
  <div>
    <div class="filter-inline-panel cle">
      <el-form :inline="true" size="mini" :model="filters" class="filter-panel fl">
      </el-form>
      <div class="list-opinion fr">
        <el-button type="primary" size="mini" @click="add()" v-if="hasBtn('add')">{{$t('index.add')}}</el-button>
      </div>
    </div>
    <el-table :data="list" border row-key="id" size="mini" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
      <el-table-column :prop="lang=='cn'?'title_cn':'title'" align="center" :label="$t('tidings_index.title')"></el-table-column>
      <el-table-column prop="user_type" align="center" :label="$t('tidings_index.user_type')" :formatter="type_f"></el-table-column>
      <el-table-column :prop="lang=='cn'?'content_cn':'content'" align="center" :label="$t('tidings_index.content')"></el-table-column>
      <el-table-column prop="show_time" align="center" :label="$t('tidings_index.show_time')" :formatter="show_time_f"></el-table-column>
      <el-table-column :label="$t('index.operation')" align="center"  fixed="right" width="160">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="add(scope.row)">{{$t('tidings_index.view_details')}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="page-pagination">
      <el-pagination align="right" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pager-count="5"></el-pagination>
    </div>
    <el-dialog :title="$t('index.dialog_title')" width="900px" :close-on-click-modal="false" :visible="editFormVisible" @close="editFormVisible = false">
      <el-form :model="editForm" size="mini" :disabled="editForm.id" label-width="80px" label-position="top" :rules="editFormRules" ref="editForm">
        <el-row class="tree-content" :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('index.cn')+$t('tidings_index.title')"  prop="title_cn">
              <el-input v-model="editForm.title_cn" class="w100" :placeholder="$t('index.pleaseInput')" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('index.en')+$t('tidings_index.title')" prop="title">
              <el-input v-model="editForm.title" class="w100":placeholder="$t('index.pleaseInput')" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('tidings_index.user_type')" prop="user_type">
              <el-select v-model="editForm.user_type" class="w100" :placeholder="$t('index.select')">
	            <el-option :label="lang=='cn'?item.name_cn:item.name" :value="item.code" v-for="(item,index) in MESSAGE_TYPE" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('tidings_index.show_time')" prop="show_time">
            	<el-date-picker v-model="editForm.show_time" type="datetime" :placeholder="$t('index.select')" value-format="timestamp"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="tree-content" :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('index.cn')+$t('tidings_index.content')" prop="content_cn">
              <el-input v-model="editForm.content_cn" :placeholder="$t('index.pleaseInput')" class="w100" type="textarea" :autosize="{ minRows: 6, maxRows: 6}"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('index.en')+$t('tidings_index.content')" prop="content">
              <el-input v-model="editForm.content" :placeholder="$t('index.pleaseInput')" class="w100" type="textarea" :autosize="{ minRows: 6, maxRows: 6}"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="!editForm.id">
        <el-button size="mini" @click.native="editFormVisible = false">{{$t('index.cancel')}}</el-button>
        <el-button size="mini" type="primary" @click.native="editSubmit('editForm')">{{$t('index.submit')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
	computed: {
		editFormRules(){
			return{
				title: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.en')+ this.$t('tidings_index.title'),
					trigger: 'blur'
				}],
				title_cn: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.cn')+ this.$t('tidings_index.title'),
					trigger: 'blur'
				}],
				user_type: [{
					required: true,
					message: this.$t('index.select')+this.$t('tidings_index.user_type'),
					trigger: 'change'
				}],
				content_cn: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.cn')+ this.$t('tidings_index.content'),
					trigger: 'blur'
				}],
				content: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.en')+ this.$t('tidings_index.content'),
					trigger: 'blur'
				}],
			}
		},
	},
	data() {
		return {
			is_co:sessionStorage.getItem('is_co') || '',
			image_up: process.env.API_UP,
			list: [],
			editFormVisible: false,
			editForm: {
			},
			image: '',
			filters: {
				type: '',
			},
			pages: {
				page: 1,
				count: 100,
				perpage: 50,
			},
			MESSAGE_TYPE:[],
		}
	},
	// 初始事件
	mounted: function () {
		this.config();
		this.init();
	},
	// 事件
	methods: {
		config(){
			var this_ = this;
			var url = "getDictionaryValue";
			var datas = {
				code:"MESSAGE_TYPE"
			};
			this_.$post(url, datas).then((res) => {
				this_.MESSAGE_TYPE = res.MESSAGE_TYPE;
			})
		},
		// 初始化
		init() {
			var this_ = this;
			var url = "MessageList";
			var datas = {
				type: this_.filters.type,
			};
			this_.$post(url, datas).then((res) => {
				this_.list = res.list;
				this_.pages.count = res.sum;
			})
		},
		add(data) {
			if (data) {
				var data_data=JSON.parse(JSON.stringify(data));
				this.editForm = data_data;
				if (data_data.show_time) {
					this.editForm['show_time']=data_data.show_time*1000;
				}
				
			} else {
				this.editForm = {
					title: '',
					title_cn: '',
					user_type: '',
					show_time: '',
					content: '',
					content_cn: '',
				}
			}
			if (this.$refs.editForm) {
				this.$refs.editForm.resetFields();
			}
			this.editFormVisible = true;
		},
		// 保存
		editSubmit(editForm) {
			var this_ = this;
			this_.$refs.editForm.validate((valid) => {
				if (valid) {
					var datas = {
						title_cn: this_.editForm.title_cn,
						title: this_.editForm.title,
						user_type: this_.editForm.user_type,
						show_time:Math.round(this_.editForm.show_time/1000),
						content_cn: this_.editForm.content_cn,
						content: this_.editForm.content,
					}
					var url = "sendCommonMessage";
					var tishi = this_.$t('index.add_success');
					if (this_.editForm.id) {
						datas['id'] = this_.editForm.id;
						tishi = this_.$t('index.modify_success');
					}
					this_.$post(url, datas).then((res) => {
						this_.$message.success(tishi);
						this_.editFormVisible = false;
						this_.init();
					});
				} else {
					return false;
				}
			})
		},
		type_f(w, s, d) {
			var this_ = this;
			var list=this_.MESSAGE_TYPE;
			var name='';
			list.forEach(function(e,i) {
				if (e.code==d) {
					name=this_.lang=='cn'?e.name_cn:e.name;
				}
			});
			return name
		},
		show_time_f(w, s, d){
			return d?(this.getTime_us(d,'mmddyyyy')+'  '+this.getTime_us(d,'hh:ii')):'';
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		}
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.filter-inline-panel {
	margin-bottom: 22px;
}
.page-pagination {
	padding: 20px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/tidings/index.vue